var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"adm-tabs-slots"},[_c('adm-tabs',{attrs:{"id":_vm.id,"activeTab":_vm.activeTab,"size":_vm.size,"tabs":_vm.tabs,"variant":_vm.variant},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._t("default",null,{"selected":_vm.selected})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }